<div class="card">
    <div class="card-header">
        Employee Closing Detail
    </div>
    <div class="card-body">

        <div class="row align-items-center user-card">
            <!-- Image -->
            <div class="col-1 text-center">
                <img *ngIf="data.photo" class="userImage" [src]="common.PhotoLink(data.photo)" />

                <div *ngIf="!data.photo" class="initial-image">
                    <div class="image">
                        {{ data[0].FullName.charAt(0) }}
                    </div>
                </div>
            </div>

            <!-- Details -->
            <div class="col-11 userdetail d-flex flex-column justify-content-center">
                <span class="emp-name mb-1">{{ data[0].FullName }}</span>
                <span class="emp-code mb-1">#{{ data[0].EmpCode }}</span>
                <span class="emp-designation">{{ data[0].designation }}</span>
            </div>

        </div>

        <div class="mx-1 mt-3">
            <table datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger"
                class="table table-bordered overflow-auto customeDatatable table-sm">
                <thead>
                    <tr>
                        <th style="width:40px">#</th>
                        <th>Leave Type</th>
                        <th>Leave Balance</th>
                        <th>Action</th>
                        <th>Count</th>
                        <th style="width:300px">Description</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let e of data; let i = index">
                        <th class="text-center" style="width:40px">{{i+1}}</th>
                        <td class="text-center">{{e['LeaveName']}}</td>
                        <td class="text-center">{{e['Closing']}}</td>
                        <td>
                            <ng-select class="custom-dropdown" name="action{{i}}" [items]="Actions" bindLabel="label"
                                bindValue="value" [(ngModel)]="e['action']" placeholder="Select Action"
                                [clearable]="false">
                            </ng-select>
                        </td>
                        <td>
                            <input type="number" [(ngModel)]="e['count']" class="form-control"
                                [disabled]="e['action'] == 'No Action'">
                        </td>
                        <td style="width:300px">
                            <textarea [rows]="2" [(ngModel)]="e['description']" class="form-control"
                                [disabled]="e['action'] == 'No Action'" placeholder="Description"></textarea>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="close()" class="btn btn-outline-primary btn-sm">
                    X Close
                </button>
            </div>
        </div>
    </div>
</div>